import type { Persister } from '@tanstack/react-query-persist-client';
import type { PersistedClient } from '@tanstack/query-persist-client-core';
import { db } from './db';

const CACHE_KEY = 'rq-cache';

/**
 * Persistencia del cache de TanStack Query en IndexedDB (no localStorage).
 * Si IndexedDB no está disponible (modo privado agresivo), se degrada a no-op
 * para no romper la aplicación.
 */
export const queryPersister: Persister = {
  persistClient: async (client: PersistedClient) => {
    try {
      await db.kv.put({ key: CACHE_KEY, value: client });
    } catch {
      // sin persistencia: la app sigue funcionando en memoria
    }
  },
  restoreClient: async () => {
    try {
      const row = await db.kv.get(CACHE_KEY);
      return row?.value as PersistedClient | undefined;
    } catch {
      return undefined;
    }
  },
  removeClient: async () => {
    try {
      await db.kv.delete(CACHE_KEY);
    } catch {
      // noop
    }
  },
};
